import { render } from "./StoreOnboardingStepContacts.vue?vue&type=template&id=24648e1f"
import script from "./StoreOnboardingStepContacts.vue?vue&type=script&lang=js"
export * from "./StoreOnboardingStepContacts.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreOnboardingStepContacts.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_268f0eba%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fstore%2Fdetails%2Fonboarding%2FStoreOnboardingStepContacts.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__